<template>
  <div class="edit-user-page">
    <div class="edit-user">
      <img :style="{transform: this.$lang === 'ar' ? 'rotateY(180deg)' : 'rotateY(0deg)'}" :src="image" />
      <div :class="[this.$lang === 'ar' ? 'right-dir' : 'left-dir', 'card-content']">
        <div :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'header']">
          <span class="titles">{{ $t('profile.editProfileDialog')}}</span>
          <img @click="close" class="close-btn" src="../../../assets/icons/closeBtn.svg">
        </div>
        <div class="body row">
          <div class="input-container col-6">
            <label :style="{left:  this.$lang === 'ar' ? 'unset' : '30px', right:  this.$lang === 'ar' ? '30px' : 'unset' }" v-if="!selectedCity.value" :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.personalInfo.city').slice(0, -1) }}</label>
            <vue-simple-select @change="change('city', selectedCity.value)" v-model="selectedCity" :options="cities"/>
            <span :style="{ opacity: isSubmitted && !$v.city.required ? 1 : 0}" class="validation">{{ $t('ProfileValidation.city') }}</span>
          </div>
          <div class="input-container col-6 ">
            <label :style="{left:  this.$lang === 'ar' ? 'unset' : '30px', right:  this.$lang === 'ar' ? '30px' : 'unset' }" v-if="!selectedGender.value && selectedGender.value !== 0"  :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.personalInfo.gender').slice(0, -1) }}</label>
            <vue-simple-select @change="change('gender', selectedGender.value)" v-model="selectedGender" :options="genders"/>
            <span :style="{ opacity: isSubmitted && !$v.gender.required ? 1 : 0}" class="validation">{{ $t('ProfileValidation.gender') }}</span>
          </div>
          <div class="input-container col-md-6 col-12">
            <label :style="{left:  this.$lang === 'ar' ? 'unset' : '30px', right:  this.$lang === 'ar' ? '30px' : 'unset' }"  v-if="!selectedJob.value"  :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.personalInfo.job').slice(0, -1) }}</label>
            <vue-simple-select @change="change('job', selectedJob.value)"  v-model="selectedJob" :options="jobs"/>
            <span :style="{ opacity: isSubmitted && !$v.job.required ? 1 : 0}" class="validation">{{ $t('ProfileValidation.job') }}</span>
          </div>
          <div class="input-container col-md-6 col-12">
            <label :style="{left:  this.$lang === 'ar' ? 'unset' : '30px', right:  this.$lang === 'ar' ? '30px' : 'unset' }" v-if="date.length === 0"  :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.personalInfo.birth').slice(0, -1) }}</label>
            <Calendar
              ref="date"
              dateFormat="yy-mm-dd"
              v-model="date" />
            <span :style="{ opacity: isSubmitted && !$v.date.required ? 1 : 0}" class="validation">{{ $t('ProfileValidation.date') }}</span>
          </div>
          <div class="input-container col-12">
            <label :style="{left:  this.$lang === 'ar' ? 'unset' : '30px', right:  this.$lang === 'ar' ? '30px' : 'unset' }" v-if="email.length === 0"  :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.personalInfo.email').slice(0, -1) }}</label>
            <input :dir="this.$lang === 'ar' ? 'rtl' : 'ltr'" v-model="email" class="field w-100" type="email">
            <span v-if="isSubmitted && email === ''" :style="{ opacity: isSubmitted && !$v.email.required ? 1 : 0}" class="validation">{{ $t('ProfileValidation.email.required') }}</span>
            <span :style="{ opacity: isSubmitted && !$v.email.email ? 1 : 0}" class="validation">{{ $t('ProfileValidation.email.valid') }}</span>
          </div>
          <div class="input-container col-12">
            <label :style="{left:  this.$lang === 'ar' ? 'unset' : '30px', right:  this.$lang === 'ar' ? '30px' : 'unset' }" v-if="address.length === 0"  :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.personalInfo.address').slice(0, -1) }}</label>
            <input :dir="this.$lang === 'ar' ? 'rtl' : 'ltr'" v-model="address" class="field w-100" type="text">
            <span :style="{ opacity: isSubmitted && !$v.address.required ? 1 : 0}" class="validation">{{ $t('ProfileValidation.address') }}</span>
          </div>
        </div>
      </div>
      <div>
        <button>
          <div @click="handleSubmit" :class="[this.$lang === 'ar' ? 'yellow-button-ar' : 'yellow-button-en', 'yellow-button flex-center']">
            <div :class="[this.$lang === 'ar' ? 'white-blur-right' : 'white-blur-left','white-blur']"></div>
            <div v-if="load" class="spinner-border text-light" role="status">
            </div>
            <span v-if="!load" :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en','save-btn']"><a>{{$t('profile.save')}}</a></span>
          </div>
        </button>
      </div>
      <div :class="[this.$lang === 'ar' ? 'blur-outer-button-ar' : 'blur-outer-button-en' ,'blur-outer-button']"></div>
    </div>
  </div>
</template>
<script>
import VueSimpleSelect from 'vue-simple-custom-select'
import UpdateProfileRepository from '../../../repositories/UpdateProfileRepository'
import CitiesRepository from '../../../repositories/CitiesRepository'
import JobsRepository from '../../../repositories/JobsRepository'
import mobileCard from '../../../assets/icons/reservationFormSmall.svg'
import pcCard from '../../../assets/images/edit-profile-card.png'
import Calendar from 'primevue/calendar'
import ms from '../../../utils/messeging.js'
import $ from 'jquery'
import { required, email } from 'vuelidate/lib/validators'
export default {
  components: { VueSimpleSelect, Calendar },
  data () {
    return {
      image: this.$store.state.window > 767 ? pcCard : mobileCard,
      updateRepo: new UpdateProfileRepository(),
      jobRepo: new JobsRepository(),
      citiesRepo: new CitiesRepository(),
      lang: this.$lang,
      selectedGender: { label: '', value: '' },
      selectedCity: { label: '', value: '' },
      selectedJob: { label: '', value: '' },
      email: '',
      address: '',
      date: '',
      cities: [],
      jobs: [],
      gender: '',
      city: '',
      job: '',
      genders: [{ label: 'Male', value: 0 }, { label: 'Female', value: 1 }],
      load: false,
      isSubmitted: false
    }
  },
  validations: {
    gender: {
      required
    },
    city: {
      required
    },
    job: {
      required
    },
    email: {
      required,
      email
    },
    date: {
      required
    },
    address: {
      required
    }
  },
  created () {
    this.fetchCities()
    this.fetchJobs()
    this.$watch(() => {
      return this.$store.state.window
    }, val => {
      this.image = val > 767 ? pcCard : mobileCard
    })
  },
  watch: {
  },
  mounted () {
    setTimeout(() => {
      $('.edit-user-page').css('top', '0')
    })
  },
  methods: {
    change (param, val) {
      this[param] = val
    },
    async fetchCities () {
      try {
        const response = await this.citiesRepo.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.cities.push({ label: response.data[i].name, value: response.data[i].id })
          }
        }
      } catch (e) {
      }
    },
    async fetchJobs () {
      try {
        const response = await this.jobRepo.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.jobs.push({ label: response.data[i].name, value: response.data[i].id })
          }
        }
      } catch (e) {
      }
    },
    async handleSubmit () {
      this.isSubmitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        // console.log('error')
        return
      }
      this.load = true
      try {
        const formData = new FormData()
        formData.append('gsm', localStorage.getItem('gsm'))
        formData.append('jobId', this.selectedJob.value)
        formData.append('address', this.address)
        formData.append('email', this.email)
        formData.append('cityId', this.selectedCity.value)
        formData.append('birthDate', this.$refs.date.inputFieldValue)
        formData.append('gender', this.selectedGender.value)
        const response = await this.updateRepo.put(formData)
        if (response.data.status === 200) {
          ms.successMessage(response.data.message)
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        ms.errorMessage('Something went wrong')
      }
      this.load = false
      this.close()
    },
    close () {
      $('.edit-user-page').css('top', '-100%')
      setTimeout(() => {
        this.$store.state.editProfile = false
      }, 300)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";
//@import "~primevue/resources/primevue.min.css";
//@import "~primeicons/primeicons.css";
.edit-user-page{
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 100000;
  left: 0;
  background: rgba(0,0,0,0.35);
  backdrop-filter: blur(20px);
  //display: flex;
  //align-items: center;
  //justify-content: center;
  transition: all .3s ease-in-out;
  top: -100%;
  overflow-y: auto;
}
.edit-user {
  width: 590px;
  height: 530px;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.edit-user > img {
  height: 100%;
  width: 100%
}
.card-content{
  height: 80%;
  width: 90%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000
}
/*------------- header -----------------*/
.header {
  padding-top: 1.5rem
}
.close-btn{
  height: 25px;
  width: 25px;
  display: inline-block;
  float: right;
  cursor: pointer;
}
.titles {
  font-size: 20px
}
/*---------------------------------------*/
/*---------------- inputs field ----------------*/
.body {
  margin-top: 1rem
}
.input-container {
  position: relative;
  padding: 0.5rem;
  text-align: initial;
}
.input-container > label {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  font-size: 13px
}
.field {
  border: 2px solid $--yellow;
  border-radius: 15px;
  height: 50px;
  padding: 15px
}
/*----------------------------------------------*/
/*------------------ button ------------------*/
.yellow-button {
  bottom: 15px !important;
}
.blur-outer-button {
  bottom: 13px !important;
}
.yellow-button-en {
  right: 89.5px
}
.blur-outer-button-en {
  right: 87.9px
}
.yellow-button-ar {
  left: 89.5px
}
.blur-outer-button-ar {
  left: 87.9px
}
.save-btn {
  text-decoration: underline;
}
/*--------------------------------------------*/
/*-------------------------------- responsive ------------------------------------*/
@media (max-width: 767px) {
  .edit-user {
    width: max-content;
    height: 580px;
  }.edit-user > img {
     height: 100%;
     width: auto;
       max-width: 360px
   }
  .card-content{
    width: 92%;
    height: 82%;
    top: 15px;
    //overflow-y: auto;
    //overflow-x: hidden;
    padding: 0 7px
  }
  .header {
    padding-top: 0.5rem
  }
  .input-container {
    padding: 0.5rem 0.4rem
  }
  /*----------------- button --------------------------*/
  .yellow-button {
    height: 75px;
    width: 75px;
    bottom: 15px !important;
  }
  .blur-outer-button {
    height: 78px;
    width: 78px;
    bottom: 13.5px !important;
  }
  .yellow-button-en {
    right: 69.5px
  }
  .blur-outer-button-en {
    right: 67.5px
  }
  .yellow-button-ar {
    left: 69.5px
  }
  .blur-outer-button-ar {
    left: 67.5px
  }
}
@media (max-height: 565px) {
  .edit-user {
    top: 20px;
    transform: translate(-50%, 0%);
  }
}
/*--------------------------------------------------------------------------------*/
</style>
<style lang="scss">
@import "src/assets/sass/main";
@import "~primevue/resources/primevue.min.css";
@import "~primeicons/primeicons.css";
.edit-user-page {
  .vue-simple-select-container {
    border: 2px solid $--yellow;
    border-radius: 15px;
    height: 50px;
    width: 100%
  }
  button.vue-simple-select-button {
    height: 100%;
    width: 100%;
    overflow-y: auto;
  }
  span.vue-simple-select-selected-option {
    color: #1d1d1d;
    height: 100%
  }
  .vue-simple-select-container .vue-simple-select-option.selected {
    color: #1d1d1d !important;
    background: none
  }
  .vue-simple-select-container .vue-simple-select-icon {
    display: none !important;
  }
  .vue-simple-select-dropdown{
    z-index: 5 !important;
  }
  .vue-simple-select-container .vue-simple-select-dropdown {
    background: linear-gradient(45deg, rgba(242, 242, 242, 0.8), rgba(255, 255, 255, 1)) !important;
    padding: 0 !important;
    max-height: 230px;
    overflow-y: auto;
  }
  ul.vue-simple-select-list {
    background: transparent !important;
    border: none;
    height: 100%;
  }
  /*--------------------date picker --------------------*/
  span.p-calendar.p-component.p-inputwrapper {
    border: 2px solid #FFCB05;
    border-radius: 15px;
    height: 50px;
    width: 100%;
    padding: 0.5rem
  }
  .p-datepicker.p-component {
    background: #FFFFFF;
    border: 1px solid $--yellow;
    border-radius: 15px;
    min-width: 250px;
    left: unset !important;
  }
  .p-datepicker-group-container {
    padding: 10px 20px
  }
  button.p-datepicker-month.p-link {
    display: block;
    margin: 0 auto;
  }
  button.p-datepicker-prev.p-link,
  button.p-datepicker-next.p-link{
    border: 2px #FFCB05 solid;
    border-radius: 50px;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /*----------------------------------------------------*/
}
</style>
